import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {DayHour, Place} from '../../../../models/place';
import {DatePipe, NgClass, NgForOf, NgIf, NgStyle} from '@angular/common';
import {User} from '../../../../models/user';
import {AuthService} from '../../../../services/auth.service';
import {Subject, takeUntil} from 'rxjs';
import moment from 'moment';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-place-detail-hours',
  imports: [
    NgIf,
    NgClass,
    NgStyle,
    DatePipe,
    RouterLink,
    NgForOf
  ],
  templateUrl: './place-detail-hours.component.html',
  styleUrl: './place-detail-hours.component.scss'
})
export class PlaceDetailHoursComponent implements OnInit, OnDestroy {
  onDestroy$ = new Subject<boolean>();

  @Input() place!: Place

  showHours = false

  date: moment.Moment = moment()

  dates: {
    day: number,
    weekDay: string,
    keyDay: string,
  }[] = [];

  now: number = 0

  currentUser: User | null = null;

  constructor(private authService: AuthService) {
    this.authService.currentUser$.pipe(takeUntil(this.onDestroy$)).subscribe(currentUser => {
      if (currentUser) this.currentUser = currentUser
    })
  }

  ngOnInit() {

    // Get the range of the dates
    this.date = moment();
    let start = this.date.clone().startOf('week');
    const end = start.clone().add(7, 'days');
    this.dates = [];
    while (start.valueOf() < end.valueOf()) {
      this.dates.push({
        day: start.toDate().getDay(),
        weekDay: start.format('dddd'),
        keyDay: start.format('dddd').toLowerCase()
      });
      start = start.clone().add(1, 'days');
    }
    this.now = this.date.toDate().getDay();
  }

  ngOnDestroy() {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }

}
